// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb_container__ZRaY0"};